import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ClozeTestStyleModel } from 'gast-onset-ng/lib/cloze-test/model/cloze-test-style-model';
import { DeviceDetectorService } from 'ngx-device-detector';
import { OnsetExamDataDto } from 'src/shared/dtos/onset-exam-data-dto';
import { ConnectorAuthService } from 'src/shared/services/common/connector-auth.service';
import { ConnectorService } from 'src/shared/services/idas/connector.service';

@Component({
  selector: 'app-connector',
  templateUrl: './connector.component.html',
  styleUrls: ['./connector.component.css']
})
export class ConnectorComponent implements OnInit {

  title: string;
  subtitle: string;
  content: string;
  clozeTestStyleModel: ClozeTestStyleModel;
  cTestLogo: string;
  cTestButtonColor: string;
  mobileMode: boolean;
  totalExercise: number;
  currentExcerciseNumber: number;

  onsetExamDataDto: OnsetExamDataDto;

  isLoading = false;

  env = '';

  constructor(
    private deviceService: DeviceDetectorService,
    private connectorService: ConnectorService,
    private authService: ConnectorAuthService,
    private router: Router,
    private route: ActivatedRoute) {
  }

  ngOnInit() {
    // detect mobile
    this.mobileMode = this.deviceService.isMobile();
    console.log('is mobile device: ' + this.mobileMode);

    // generate style
    this.clozeTestStyleModel = this.generateClozeTestStyle();

    // sett logo and button color
    this.cTestLogo = 'onset-assets/img/onset_logo.png';
    this.cTestButtonColor = this.clozeTestStyleModel.onsetColor;

    this.connectorService.getOnsetExamDataCompleted.subscribe((onsetExamDataDto: OnsetExamDataDto) => {
      this.onsetExamDataDto = onsetExamDataDto;
      this.isLoading = false;

      this.authService.login(onsetExamDataDto);
    });

    // callback for query parameter
    this.route.queryParams.subscribe(params => {
      if (params['token']) {
        const token = params['token'] as string;
        if (params['env']) {
          this.env = params['env'];
        }

        this.connectorService.getOnsetExamData(token, this.env);
        this.isLoading = true;
      }
      
    });
  }

  startOnset(): void {
    this.router.navigate(['connector-onset'], { queryParamsHandling: 'preserve' });
  }

  private generateClozeTestStyle(): ClozeTestStyleModel {
    // TODO config
    const model = {} as ClozeTestStyleModel;
    model.siteBackground = '#ffffff';
    model.exerciseBackground = '#EEF3F8';
    model.frameColor = '#92aac1';
    model.barColor = '#b3c9de';
    model.specialCharacterListColor = '#b3c9de';
    model.specialChcaracterTextColor = '#000000';
    model.exerciseTextColor = '#000000';
    model.buttonsColor = '#fa9463';
    model.testdafColor = '#57a7d6';
    model.onsetColor = '#a5d8db';
    model.duoColor = '#ed6a5b';
    model.testasColor = '#fac075';
    model.font = 'arial, helvetica, sans-serif';
    model.fontSize = '11pt';
    model.displayLogo = true;
    model.cTestInformationUrl = 'http://www.wikipedia.com/';
    return model;
  }
}
